import Vue from 'vue'
import Router from 'vue-router'
import S404 from "@/pages/S404"
import Home from "@/pages/Home"
import Login from "@/pages/Login/Login"
import accountAdmin from "@/pages/Login/add"


import diyIndex from "@/pages/DIY/index"
import homeSecondhandBanner from "@/pages/homeSecondhandBanner/index"



import user from "@/pages/userAdmin/index"
import officialUserList from "@/pages/officialUserList/index.vue"


// 品牌
import brand from "@/pages/brand/index"



// 意见反馈
import feedback from "@/pages/feedback/index"
import feedbackReply from "@/pages/feedback/reply"


// 常见问题
import problem from "@/pages/problem/index"



// 常见问题
import logistics from "@/pages/logistics/index"




// 商品订单
import consignmentOrder from "@/pages/goodsOrder/consignmentOrder"
import consignmentGrade from "@/pages/consignmentGrade/index.vue"
import verificationOrder from "@/pages/goodsOrder/verificationOrder"


// 鉴别作业
import inspectionJob from "@/pages/inspectionJob/index"
import inspectionJobDetail from "@/pages/inspectionJob/detail"
import deliveryList from "@/pages/inspectionJob/deliveryList"



//基础设置
import Recharge from "@/pages/RechargeAdmin/add"
import logisticsMoney from "@/pages/RechargeAdmin/logisticsMoney"
import sysSetting from "@/pages/sysSetting/index"
import sensitiveWord from "@/pages/sensitiveWord/index"
import dictMgmtDictType from "@/pages/dictMgmt/dictType/index.vue"

//批号查询管理
import brandLogic from "@/pages/batchQuery/brandLogic"
import specConfig from "@/pages/batchQuery/specConfig"
import noBrandQueryRecord from "@/pages/batchQuery/noBrandQueryRecord"
import contributionBatchTable from "@/pages/batchQuery/contributionBatchTable"
import typeSearchMiss from "@/pages/batchQuery/typeSearchMiss"


//商品发布
import secondhandProduct from "@/pages/secondhandProduct/index";
//二手交易订单
import secondhandOrder from "@/pages/secondhandOrder/index";
// 安心购订单（后台专用）
import secondhandInspectionOrder from "@/pages/secondhandInspectionOrder/index.vue";
import secondhandInspectionCenterShipRemind from "@/pages/secondhandInspectionCenterShipRemind/index.vue";
import secondhandPickupFreightAppeal from "@/pages/secondhandPickupFreightAppeal/index.vue";
import secondhandSellerReturnFreight from "@/pages/secondhandSellerReturnFreight/index.vue";
// 闲置聊天管理
import chatRecord from "@/pages/chatRecord/index";
// 小法官列表
import secondhandJuror from "@/pages/secondhandJuror/index";
// 二手纠纷列表
import secondhandDispute from "@/pages/secondhandDispute/index";
// 马甲用户维护
import secondhandJurySockPuppet from "@/pages/secondhandSockPuppet/index";








Vue.use(Router)

//初始路由
let routes0 = [
    {
        path: '/Login',
        component: Login,
        name: '登陆',
        hidden: true
    },
    {
        path: '*',
        component: S404,
        name: '404',
        hidden: true
    }
];



// 总平台权限
var adminData = [
    {
        path: '/goodsOrder/consignmentOrder',
        component: Home,
        name: '寄售订单',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/goodsOrder/consignmentOrder',
                component: consignmentOrder,
                name: '寄售订单'
            },
            {
                path: '/goodsOrder/consignmentGrade',
                component: consignmentGrade,
                name: '寄售评级'
            }
        ]
    },
    {
        path: '/goodsOrder/verificationOrder',
        component: Home,
        name: '鉴别订单',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/goodsOrder/verificationOrder',
                component: verificationOrder,
                name: '鉴别订单'
            }
        ]
    },
	{
        path: '/inspectionJob',
        component: Home,
        name: '鉴别作业',
        iconCls: 'el-icon-s-order',
        leaf: true,
        children: [
            {
                path: '/inspectionJob/index',
                component: inspectionJob,
                name: '平台鉴别'
            },
            {
                path: '/inspectionJob/deliveryList',
                component: deliveryList,
                name: '待发货列表'
            }
        ]
    },
    {
        path: '/brand',
        component: Home,
        name: '品牌管理',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/brand',
                component: brand,
                name: '品牌管理'
            }

        ]
    },
    {
        path: '/user',
        component: Home,
        name: '用户管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/user',
                component: user,
                name: '用户列表'
            },
            {
                path: '/officialUserList',
                component: officialUserList,
                name: '官方帐号列表'
            }
        ]
    },

    {
        path: '/Recharge/add',
        component: Home,
        name: '基本设置',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/Recharge/add',
                component: Recharge,
                name: '基本设置'
            },
            {
                path: '/Recharge/logisticsMoney',
                component: logisticsMoney,
                name: '鉴别价格'
            }
        ]
    },
    {
        path: '/sysSetting',
        component: Home,
        name: '系统管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/sysSetting',
                component: sysSetting,
                name: '系统配置'
            },
            {
                path: '/sensitiveWord',
                component: sensitiveWord,
                name: '敏感词库'
            }
        ]
    },
    {
        path: '/dictMgmt/dictType',
        component: Home,
        name: '字典管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/dictMgmt/dictType',
                component: dictMgmtDictType,
                name: '字典类型'
            }
        ]
    },
    {
        path: '/batchQuery/brandLogic',
        component: Home,
        name: '品牌批号查询管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/batchQuery/brandLogic',
                component: brandLogic,
                name: '品牌逻辑列表'
            },
            {
                path: '/batchQuery/contributionBatchTable',
                component: contributionBatchTable,
                name: '贡献批号列表'
            },
            {
                path: '/batchQuery/noBrandQueryRecord',
                component: noBrandQueryRecord,
                name: '无品牌逻辑查询记录'
            },
            {
                path: '/batchQuery/typeSearchMiss',
                component: typeSearchMiss,
                name: '品牌搜索无结果'
            },{
            path: '/batchQuery/specConfig',
            component: specConfig,
            name: '规格管理'
          },
        ]
    },
  {
    path: "/secondhandProduct",
    component: Home,
    name: "商品管理",
    iconCls: "",
    leaf: true,
    children: [
      {
        path: "/secondhandProduct",
        component: secondhandProduct,
        name: "卖家闲置商品列表",
      },
      {
        path: "/secondhandOfficialProduct",
        component: secondhandProduct,
        name: "官方寄售商品列表",
      },
    ]
  },
  {
    path: "/secondhandOrder",
    component: Home,
    name: "闲置订单管理",
    iconCls: "",
    leaf: true,
    children: [
      {
        path: "/secondhandOrder",
        component: secondhandOrder,
        name: "闲置订单",
      },
      {
        path: "/secondhandInspectionOrder",
        component: secondhandInspectionOrder,
        name: "安心购订单",
      },
      {
        path: "/secondhandInspectionCenterShipRemind",
        component: secondhandInspectionCenterShipRemind,
        name: "催促验货发货通知",
      },
      {
        path: "/secondhandPickupFreightAppeal",
        component: secondhandPickupFreightAppeal,
        name: "退货运费申诉",
      },
      {
        path: "/secondhandSellerReturnFreight",
        component: secondhandSellerReturnFreight,
        name: "卖家待付退货运费",
      },
    ],
  },
  {
    path: "/chatRecord",
    component: Home,
    name: "买卖家聊天",
    iconCls: "",
    leaf: false,
    children: [
      {
        path: "/chatRecord",
        component: chatRecord,
        name: "闲置聊天管理",
      },
    ],
  },
  {
    path: "/smallCourtMgmt",
    component: Home,
    name: "小法庭管理",
    iconCls: "",
    leaf: true,
    children: [
      {
        path: "/secondhandJuror",
        component: secondhandJuror,
        name: "小法官列表",
      },
      {
        path: "/secondhandDispute",
        component: secondhandDispute,
        name: "纠纷订单列表",
      },
      {
        path: "/secondhandJurySockPuppet",
        component: secondhandJurySockPuppet,
        name: "马甲用户",
      },
    ]
  },
    {
        path: '/feedback',
        component: Home,
        name: '反馈意见',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/feedback',
                component: feedback,
                name: '反馈意见'
            },
            {
                path: '/feedback/reply',
                component: feedbackReply,
                name: '意见处理'
            }
        ]
    },
    {
        path: '/problem',
        component: Home,
        name: '常见问题',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/problem',
                component: problem,
                name: '常见问题'
            }

        ]
    },
    {
        path: '/',
        component: Home,
        name: '界面管理',
        iconCls: '',
        leaf: true,
        children: [
            {
                path: '/index',
                component: diyIndex,
                name: '轮播图'
            },
            {
                path: '/homeSecondhandBanner',
                component: homeSecondhandBanner,
                name: '广告位'
            },

        ]
    },
    {
        path: '/logistics',
        component: Home,
        name: '物流公司',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/logistics',
                component: logistics,
                name: '物流公司'
            }

        ]
    },
      {
        path: '/accountAdmin',
        component: Home,
        name: '密码设置',
        iconCls: '',
        leaf: false,
        children: [
            {
                path: '/accountAdmin',
                component: accountAdmin,
                name: '密码设置'
            }

        ]
    },





    // {
    //     path: '/',
    //     component: Home,
    //     name: '招聘求职',
    //     iconCls: '',
    //     leaf: true,
    //     children: [
    //         {
    //             path: '/recruit',
    //             component: recruit,
    //             name: '待审核'
    //         },
    //         {
    //             path: '/recruitInfo',
    //             component: recruitInfo,
    //             name: '招聘求职'
    //         }
    //     ]
    // },



];


// 子商户
var adminData2 = [

]




export default new Router({
    routes: routes0
})


function getRoute(type) {
    if(type == 1){
        // 平台管理权限
        return adminData
    } if(type == 2){
        // 子商户
        return adminData2
    }else{
        // 未登陆
        return routes0
    }

}



export {getRoute};



// WEBPACK FOOTER //
// ./src/router/index.js